import React, { useState, useEffect, useContext, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import "../SystematicReviews/App.css";


const RemoveItemPopup = ({ globalContext }) => {

    let AppContext = globalContext;

    const [isDeleting, setIsDeleting] = useState(false);

    let id = AppContext.selectedSRProjectToDelete.Id;
    let title = AppContext.selectedSRProjectToDelete.Title;



    const deleteProject = () => {

        let deleteUrl = AppContext.dataTableStructure.dataUrl + `?` +
            `Id=${encodeURIComponent(id)}&`;

        let requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };

        setIsDeleting(true);

        fetch(deleteUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((result) => {

                // Delete the item in the existing data array
                const updatedDataArray = AppContext.data.filter(item => item.Id !== id);
                AppContext.setData(updatedDataArray);

                // Close popup
                AppContext.showRemoveItemPopup(false);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsDeleting(false);
            });

    }



    return (
        <div className="add-task-popup" style={{ width: "30%", position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Delete {AppContext.singleItemTitle}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showRemoveItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <div style={{textAlign: "center"}}>
                <br />
                <br />
                Are you sure you want to remove this item:
                <br/>
                <br/>
                "{title}"
            </div>
            

            {/* BUTTONS */}

            <div className="action-button-bar">
                <div className="action-button-bar-left">
                    <button
                        className="action-button cancel-button"
                        onClick={() => AppContext.showRemoveItemPopup(false)}
                    >
                        Cancel
                    </button>
                </div>
                <div className="action-button-bar-center"></div>
                <div className="action-button-bar-right">

                        {isDeleting? 
                        <>
                            <LoadingSpinnerImage />
                        </> : <>
                            <button
                            className="action-button delete-button"
                            onClick={() => deleteProject()}
                        >
                            Delete
                            </button>
                        </>}

                </div>
            </div>

        </div>
    );
};


export default RemoveItemPopup;

